import "./styles.css";

interface ThermometerProps {
    label: string;
    score: number;
    maxScore: number;
}

export const Thermometer = ({ label, score, maxScore }: ThermometerProps) => {
    const getColor = (score: number): string => {
        if (score < 4) return "#4ade80"; // groen
        if (score <= 6) return "#fbbf24"; // geel
        return "#ef4444"; // rood
    };

    const percentage = (score / maxScore) * 100;
    const color = getColor(score);
    const thresholdPercentage = (4 / maxScore) * 100;

    return (
        <div className="thermometer-container">
            <div className="thermometer-label">{label}</div>
            <div className="thermometer">
                <div className="thermometer-scale">
                    {/* Drempelstreep bij 4 */}
                    <div
                        className="threshold-line"
                        style={{ bottom: `${thresholdPercentage}%` }}
                    />
                    {/* Vulling */}
                    <div
                        className="thermometer-fill"
                        style={{
                            height: `${percentage}%`,
                            backgroundColor: color
                        }}
                    />
                </div>
                {/* Labels buiten de scale voor zichtbaarheid */}
                <div className="thermometer-labels">
                    <span className="scale-label-top">{maxScore}</span>
                    <span
                        className="threshold-label"
                        style={{ bottom: `${thresholdPercentage}%` }}
                    >
                        4
                    </span>
                </div>
            </div>
            <div className="thermometer-score">
                Score: <strong>{score}</strong> / {maxScore}
            </div>
        </div>
    );
};
